'use client'
import { Box, Flex, Group, Skeleton, Stack } from '@mantine/core'
import { useTranslations } from 'next-intl'
import React, { Suspense, useMemo } from 'react'

import { SectionErrorBoundary } from '@/components/error/boundary'
import { useCryptoBasket } from '@/services/invest'

import CardsContainer from '../CardsContainer'
import BasketCard, { type BasketCardProps } from './BasketCard'

function BasketFallback() {
  return (
    <Box>
      <Flex justify="space-between" align="flex-end" w="100%" mb={24}>
        <Stack maw="calc(90% - 80px)" gap={8}>
          <Skeleton
            h={32}
            w={160}
            radius="xl"
            style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
          />
          <Skeleton
            h={24}
            w={400}
            radius="xl"
            style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
          />
        </Stack>
        <Skeleton
          h={44}
          w={120}
          radius="md"
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
      </Flex>
      <Group wrap="nowrap" gap="md">
        <Skeleton
          h={240}
          w={300}
          radius="md"
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
        <Skeleton
          h={240}
          w={300}
          radius="md"
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
        <Skeleton
          h={240}
          w={300}
          radius="md"
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
        <Skeleton
          h={240}
          w={300}
          radius="md"
          style={{ backgroundColor: 'var(--bg-surface-secondary)' }}
        />
      </Group>
    </Box>
  )
}

function BasketContent() {
  const { data: basket } = useCryptoBasket()
  const t = useTranslations('baskets')

  const data = useMemo(() => {
    const dataList: BasketCardProps[] = []
    // Add basket card
    if (basket?.crypto_baskets.length > 0) {
      basket.crypto_baskets.slice(0, 4).map(item => {
        dataList.push({
          title: item.title,
          image: item.banner_url,
          updateTime: item.updated_at,
          tagIcons: item.coins,
          badge: t('badge.mostTraded'),
          updatePercentage: item.price_change?.percentage,
        })
      })
    }
    return dataList.filter(Boolean)
  }, [basket, t])

  if (!basket || basket.crypto_baskets.length === 0) return null

  return (
    <CardsContainer
      title={t('title')}
      description={t('description')}
      data={data}
      link="https://web.crypto.com/signup"
      render={(item, idx) => <BasketCard key={idx} {...item} />}
    />
  )
}

function Baskets() {
  return (
    <Suspense fallback={<BasketFallback />}>
      <BasketContent />
    </Suspense>
  )
}

export default SectionErrorBoundary.with(Baskets)
